import { render, staticRenderFns } from "./PanelProvisionList.vue?vue&type=template&id=fbf17c3c&scoped=true&"
import script from "./PanelProvisionList.vue?vue&type=script&lang=js&"
export * from "./PanelProvisionList.vue?vue&type=script&lang=js&"
import style0 from "./PanelProvisionList.vue?vue&type=style&index=0&id=fbf17c3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf17c3c",
  null
  
)

export default component.exports